<template>
  <div class="welcome">
    <el-card class="box-card welcome-container">
      <img
        src="@/assets/images/logo.png"
        class="welcome-image"
        alt
        srcset
        @click="$router.push('/')"
      />
      <!-- <login-input v-if="displayedComponent === 'login'" @goActivation="changePage('activation')"/> -->
      <el-input
        class="welcome-input"
        v-model="orderNo"
        :placeholder="this.$_strings.tracking.placeholderOrderNo"
      />
      <el-button
        class="welcome-button"
        type="primary"
        @click="submitOrderNo"
      >{{ this.$_strings.common.track }}</el-button>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      orderNo: '',
      orderDetail: {},
      orderExist: true
    }
  },
  methods: {
    submitOrderNo: async function () {
      await this.searchOrder(this.orderNo)
      if (this.orderExist) {
        this.$router.push({
          name: 'Order Detail',
          params: {
            orderNo: this.orderNo,
            order: this.orderDetail
          }
        })
      } else {
        this.orderExist = true
      }
    },
    searchOrder: async function (value) {
      let loadingInstance = this.$loading()
      // await this.$_services.order.searchOrder(value)
      await this.$_services.orderByShipment.searchOrder(value)
        .then(result => {
          console.log('TCL: fetchOrderTrackingDetailHome -> result', result)
          if (result.data == null) {
            this.$message.error('Nomor Pesanan Tidak Ada')
            throw new Error('Data Tidak Ada')
          }
          this.$set(this, 'orderDetail', result.data)

          // this.pinToBound(this.orderDetail.originCoordinate, this.orderDetail.destinationCoordinate)
        })
        .catch(err => {
          console.log('TCL: fetchOrderTrackingDetailHome -> err', err.response)
          if (err.response.status === 400) {
            this.orderExist = false
            this.$message.error('Nomor Pesanan Tidak Ada')
          } else {
            this.orderExist = false
          }
        })
        .finally(e => {
          loadingInstance.close()
        })
    }
  }
}
</script>

<style lang="scss">
.welcome {
  &-container {
    @extend .w6, .pa3;
    margin-top: 35%;
    background-color: white;
    z-index: 9;
  }

  &-image {
    margin-bottom: 5%;
  }

  &-input {
    .el-input__inner {
      width: 90%;
    }
    margin: 2% 0% 4% 0%;
  }

  &-button {
    margin: 1% 0% 2% 0%;
    width: 90%;
  }
}
</style>
